import jwt_decode from 'jwt-decode'
import { TokenDecoded } from 'types'

export type SessaoInicial =
    | { estado: 'autenticada'; decoded: TokenDecoded }
    | { estado: 'renovar' }
    | { estado: 'anonima' }

function decodificarJwtVigente(jwt: string | undefined, agoraMs: number) {
    if (!jwt) return undefined

    try {
        const decoded = jwt_decode<TokenDecoded>(jwt)
        return decoded?.exp && decoded.exp * 1000 > agoraMs
            ? decoded
            : undefined
    } catch (_) {
        return undefined
    }
}

/**
 * Decide como a sessão começa ao abrir o app. JWT ausente, corrompido ou
 * expirado com refresh token presente pede renovação, não sessão anônima.
 */
export function resolverSessaoInicial(
    jwt: string | undefined,
    refreshToken: string | undefined,
    agoraMs = Date.now(),
): SessaoInicial {
    const decoded = decodificarJwtVigente(jwt, agoraMs)
    if (decoded) return { estado: 'autenticada', decoded }

    return refreshToken ? { estado: 'renovar' } : { estado: 'anonima' }
}
